/* eslint-disable menti-react/filename-convention--jsx */
import React from 'react';
import type { PresenterConfig } from './hooks/types';

export const QuizConfigContext = React.createContext<PresenterConfig | void>(
  undefined,
);

export const useQuizConfig = (): PresenterConfig => {
  const ctx = React.useContext(QuizConfigContext);

  if (!ctx)
    throw new Error('useQuizConfig must be used within a QuizConfigProvider');

  return ctx;
};

export const QuizConfigProvider = ({
  children,
  questionAdminKey,
  questionPublicKey,
  voteKey,
}: React.PropsWithChildren<PresenterConfig>) => {
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    setReady(!!(questionAdminKey && voteKey && questionPublicKey));
  }, [questionAdminKey, voteKey, questionPublicKey]);

  return ready ? (
    <QuizConfigContext.Provider
      value={{ questionAdminKey, voteKey, questionPublicKey }}
    >
      {children}
    </QuizConfigContext.Provider>
  ) : null;
};
